import { ChevronRight } from 'lucide-react';

interface StickyFooterActionsProps {
  isSaving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function StickyFooterActions({ isSaving, onCancel, onConfirm }: StickyFooterActionsProps) {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-end gap-3 border-t border-slate-200 bg-white p-4 xl:left-[240px]">
      <button
        type="button"
        onClick={onCancel}
        className="inline-flex h-10 items-center justify-center rounded-md border border-slate-200 bg-white px-8 sm:text-sm text-xs text-slate-700 hover:bg-slate-50 transition-all"
      >
        Hủy bỏ
      </button>
      <button
        type="button"
        disabled={isSaving}
        onClick={onConfirm}
        className="inline-flex h-10 items-center justify-center gap-2 rounded-md bg-emerald-800 px-6 sm:text-sm text-xs text-white hover:bg-emerald-900 transition-all active:scale-95 disabled:opacity-50"
      >
        <span>{isSaving ? 'Đang xử lý...' : 'Tiếp tục: Nội dung đề xuất'}</span>
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
}
